import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';
import { createTypography } from './createTypography';
var typography = createTypography();
var lineHeightScale = typography.lineHeight;

var roundToEvenNumber = function roundToEvenNumber(value) {
  return 2 * Math.round(value / 2);
};

export var createFontSizeOld = function createFontSizeOld(size) {
  var minHeight = lineHeightScale * size;
  minHeight = roundToEvenNumber(minHeight);
  return {
    fontSize: "".concat(size, "px"),
    lineHeight: lineHeightScale,
    minHeight: "".concat(minHeight, "px")
  };
};
export var typographySizeRampOld = {
  touch: {
    s100: createFontSizeOld(12),
    s200: createFontSizeOld(16),
    s300: createFontSizeOld(16),
    s400: createFontSizeOld(18),
    s500: createFontSizeOld(20),
    s600: createFontSizeOld(24),
    s700: createFontSizeOld(32),
    s800: createFontSizeOld(40),
    s900: createFontSizeOld(48),
    s1000: createFontSizeOld(58),
    s1100: createFontSizeOld(68)
  },
  low: {
    s100: createFontSizeOld(11),
    s200: createFontSizeOld(14),
    s300: createFontSizeOld(16),
    s400: createFontSizeOld(18),
    s500: createFontSizeOld(20),
    s600: createFontSizeOld(24),
    s700: createFontSizeOld(32),
    s800: createFontSizeOld(40),
    s900: createFontSizeOld(48),
    s1000: createFontSizeOld(58),
    s1100: createFontSizeOld(68)
  },
  medium: {
    s100: createFontSizeOld(11),
    s200: createFontSizeOld(12),
    s300: createFontSizeOld(14),
    s400: createFontSizeOld(16),
    s500: createFontSizeOld(18),
    s600: createFontSizeOld(22),
    s700: createFontSizeOld(30),
    s800: createFontSizeOld(36),
    s900: createFontSizeOld(44),
    s1000: createFontSizeOld(56),
    s1100: createFontSizeOld(64)
  },
  high: {
    s100: createFontSizeOld(10),
    s200: createFontSizeOld(11),
    s300: createFontSizeOld(12),
    s400: createFontSizeOld(14),
    s500: createFontSizeOld(16),
    s600: createFontSizeOld(20),
    s700: createFontSizeOld(26),
    s800: createFontSizeOld(32),
    s900: createFontSizeOld(40),
    s1000: createFontSizeOld(50),
    s1100: createFontSizeOld(60)
  }
};
export var typographyWeightRampOld = {
  w300: _assign({}, typography.getFace('light')),
  w400: _assign({}, typography.getFace()),
  w600: _assign({}, typography.getFace('semiBold')),
  w700: _assign({}, typography.getFace('bold'))
};

var createPalette = function createPalette(_ref) {
  var type = _ref.type,
      grey60 = _ref.grey60,
      grey300 = _ref.grey300,
      grey900 = _ref.grey900,
      white = _ref.white,
      unknown = _ref.unknown;

  if (type === 'light') {
    return {
      color1: grey900,
      color2: grey300,
      color3: white,
      color4: white,
      unknown: unknown
    };
  } else {
    return {
      color1: white,
      color2: grey60,
      color3: grey900,
      color4: white,
      unknown: unknown
    };
  }
};

var createAction = function createAction(_ref2) {
  var color1 = _ref2.color1;
  var w600 = typographyWeightRampOld.w600;

  var action = _assign({
    color: color1,
    textTransform: 'uppercase',
    letterSpacing: 0.6
  }, w600);

  return {
    touch: action,
    low: action,
    medium: action,
    high: action
  };
};

var createActionInverted = function createActionInverted(_ref3) {
  var color3 = _ref3.color3;
  var actionInverted = {
    color: color3
  };
  return {
    touch: actionInverted,
    low: actionInverted,
    medium: actionInverted,
    high: actionInverted
  };
};

var createCaption = function createCaption(_ref4) {
  var color2 = _ref4.color2;

  var createCaptionDensity = function createCaptionDensity(density) {
    var s100 = typographySizeRampOld[density].s100;
    var w400 = typographyWeightRampOld.w400;
    return _assign({
      color: color2
    }, s100, w400);
  };

  return {
    touch: createCaptionDensity('touch'),
    low: createCaptionDensity('low'),
    medium: createCaptionDensity('medium'),
    high: createCaptionDensity('high')
  };
};

var createCaption2 = function createCaption2(_ref5) {
  var color2 = _ref5.color2;
  var caption2 = {
    color: color2
  };
  return {
    touch: caption2,
    low: caption2,
    medium: caption2,
    high: caption2
  };
};

var createParagraph = function createParagraph(_ref6) {
  var color1 = _ref6.color1;
  var paragraph = {
    color: color1
  };
  return {
    touch: paragraph,
    low: paragraph,
    medium: paragraph,
    high: paragraph
  };
};

var createParagraphInverted = function createParagraphInverted(_ref7) {
  var color3 = _ref7.color3;
  var paragraphInverted = {
    color: color3
  };
  return {
    touch: paragraphInverted,
    low: paragraphInverted,
    medium: paragraphInverted,
    high: paragraphInverted
  };
};

var createPrimaryAction = function createPrimaryAction(_ref8) {
  var color4 = _ref8.color4;
  var primaryAction = {
    color: color4
  };
  return {
    touch: primaryAction,
    low: primaryAction,
    medium: primaryAction,
    high: primaryAction
  };
};

var createRegular = function createRegular(_ref9) {
  var color1 = _ref9.color1;

  var createRegularDensity = function createRegularDensity(density) {
    var s200 = typographySizeRampOld[density].s200;
    var w400 = typographyWeightRampOld.w400;
    return _assign({
      color: color1,
      letterSpacing: 0
    }, s200, w400);
  };

  return {
    touch: createRegularDensity('touch'),
    low: createRegularDensity('low'),
    medium: createRegularDensity('medium'),
    high: createRegularDensity('high')
  };
};

var createSelected = function createSelected(_ref10) {
  var color4 = _ref10.color4;
  var selected = {
    color: color4
  };
  return {
    touch: selected,
    low: selected,
    medium: selected,
    high: selected
  };
};

var createSubtitle = function createSubtitle() {
  var w600 = typographyWeightRampOld.w600;
  return {
    touch: w600,
    low: w600,
    medium: w600,
    high: w600
  };
};

var createSubtitleInverted = function createSubtitleInverted(_ref11) {
  var color3 = _ref11.color3;
  var subtitleInverted = {
    color: color3
  };
  return {
    touch: subtitleInverted,
    low: subtitleInverted,
    medium: subtitleInverted,
    high: subtitleInverted
  };
};

var createGetTypography = function createGetTypography(options) {
  return function () {
    var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref12$variant = _ref12.variant,
        variant = _ref12$variant === void 0 ? 'regular' : _ref12$variant,
        _ref12$density = _ref12.density,
        density = _ref12$density === void 0 ? 'medium' : _ref12$density;

    var hasOwnProperty = Object.prototype.hasOwnProperty;

    if (!hasOwnProperty.call(options, variant) || !hasOwnProperty.call(options[variant], density)) {
      return {};
    }

    return options[variant][density];
  };
};

var createGetTypographyWithoutColor = function createGetTypographyWithoutColor(getTypography) {
  return function (getTypographyOptions) {
    var getTypographyResult = getTypography(getTypographyOptions);

    var unusedColor = getTypographyResult.color,
        colourlessOptions = _objectWithoutProperties(getTypographyResult, ["color"]);

    return colourlessOptions;
  };
};

export var createTypographyOld = function createTypographyOld(palette) {
  var typographyOld = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref13 = typeof typographyOld === 'function' ? typographyOld(palette) : typographyOld,
      otherGetTypography = _ref13.getTypography,
      otherGetTypographyDensity = _ref13.getTypographyDensity,
      otherOptions = _objectWithoutProperties(_ref13, ["getTypography", "getTypographyDensity"]);

  var typographyPalette = createPalette(palette);
  var regular = createRegular(typographyPalette);
  var action = deepmerge(regular, createAction(typographyPalette));
  var actionInverted = deepmerge(action, createActionInverted(typographyPalette));
  var caption = deepmerge(regular, createCaption(typographyPalette));
  var caption2 = deepmerge(regular, createCaption2(typographyPalette));
  var paragraph = deepmerge(regular, createParagraph(typographyPalette));
  var paragraphInverted = deepmerge(paragraph, createParagraphInverted(typographyPalette));
  var subtitle = deepmerge(regular, createSubtitle(typographyPalette));
  var subtitleInverted = deepmerge(subtitle, createSubtitleInverted(typographyPalette));
  var primaryAction = deepmerge(action, createPrimaryAction(typographyPalette));
  var selected = deepmerge(regular, createSelected(typographyPalette));
  var options = {
    regular: regular,
    action: action,
    actionInverted: actionInverted,
    caption: caption,
    caption2: caption2,
    paragraph: paragraph,
    paragraphInverted: paragraphInverted,
    primaryAction: primaryAction,
    selected: selected,
    subtitle: subtitle,
    subtitleInverted: subtitleInverted
  };
  var mergedOptions = deepmerge(options, otherOptions, {
    clone: false
  });
  var getTypography = createGetTypography(mergedOptions);
  return _assign({
    getTypography: otherGetTypography || getTypography,
    getTypographyDensity: otherGetTypographyDensity || createGetTypographyWithoutColor(getTypography)
  }, mergedOptions);
};